import SearchParamsBase from "../../../../Elements/SearchParamsBase";

export default class InvoiceEvaluatorSearchParams extends SearchParamsBase
{
	static saveType = 'InvoiceEvaluatorSearchParams';
	constructor(id)
	{
		super();
		this.ExportPaymentId = id;
	}

	initialize()
	{
		this.ExportPaymentId = '';
	}
}